import api from '@/api/index'

export default {
  getAll: async payload => {
    const response = await api.finances.getAll(payload)
    const { data } = response
    return data
  },
  get: async payload => {
    const response = await api.finances.get(payload)
    const { data } = response
    return data
  },
  save: async payload => {
    const response = await api.finances.save(payload)
    return response
  },
  destroy: async payload => {
    const response = await api.finances.destroy(payload)
    return response
  },
  queryFinances: async payload => {
    const response = await api.finances.queryFinances(payload)
    return response
  },
  bestSellingProducts: async payload => {
    const response = await api.finances.bestSellingProducts(payload)
    return response
  },
  barMechanicsFinances: async payload => {
    const response = await api.finances.barMechanicsFinances(payload)
    return response
  },
  printListInvoices: async payload => {
    const response = await api.finances.printListInvoices(payload)
    return response
  },
}
